import React from "react";

export default function InterdicaoDetalhesToFields({
  Section,
  ReadOnlyField,
  formatDate,
  interdicao,
  resolveValue,
}) {
  return (
    <Section title="Operação">
      <div className="interdDet-grid interdDet-grid--3">
        <ReadOnlyField label="Data" value={formatDate(interdicao.dataInicio)} />
        <ReadOnlyField label="Horário início" value={interdicao.horaInicio || "-"} />
        <ReadOnlyField
          label="Seção de Bloqueio"
          value={resolveValue("sb", "sbParada") || "-"}
        />
        <ReadOnlyField label="KM" value={resolveValue("kmInicial", "km") || "-"} />
        <ReadOnlyField label="Ativo" value={resolveValue("ativo", "numeroAtivo") || "-"} />
        <ReadOnlyField label="Acionamento" value={resolveValue("acionamento") || "-"} />
        <ReadOnlyField
          label="Nível de Acionamento"
          value={resolveValue("nivelAcionamento", "nivel_acionamento") || "-"}
        />
        <ReadOnlyField label="Motivo" value={resolveValue("motivo") || "-"} />
        <ReadOnlyField
          label="Obs."
          value={resolveValue("observacao") || "-"}
          wide
          multiline
        />
      </div>
    </Section>
  );
}
